import script from "./CompanyLogo.vue?vue&type=script&lang=ts"
export * from "./CompanyLogo.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__